








































































































































































































































































































// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck Fix typing issues later
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { required, requiredIf, email } from "vuelidate/lib/validators";
import {
  Dropdown,
  Input,
  Button,
  Datepicker,
  SvgIcon,
  Switcher,
} from "@brankas/web-ui";
import { namespace } from "vuex-class";
import moment from "moment";

import { ClientInfo } from "@/types";
import {
  formatTaxIdNumberUtil,
  formatPhoneNumberUtil,
  stringToNumberUtil,
  parsePhoneNumber,
} from "@/utils/common-utils";
import { FormData } from "@/pages/client-info/EditBusinessOwner.vue";
import { ECountryCode } from "@/pagesCom/ClientInfo/index.dto";

import { getAddressTitle } from "./helpers";
import { COUNTRY_MOBILE_CODES } from "@/constant";

const clientModule = namespace("client");

const initialFormData = (override = {}): FormData => ({
  fullname: "",
  placeofbirth: "",
  dateofbirth: "",
  gender: "",
  occupation: "",
  phonenumber: "",
  phonenumbercountrycode: "",
  email: "",
  isuscitizen: false,
  citizenship: "",
  taxidentificationnumber: "",

  registeredaddressline1: "",
  registeredaddressline2: "",
  registeredcountry: "",
  registeredregion: "",
  registeredcity: "",
  registeredzipcode: "",

  currentaddressline1: "",
  currentaddressline2: "",
  currentcountry: "",
  currentregion: "",
  currentcity: "",
  currentzipcode: "",

  ...override,
});

@Component({
  components: {
    Dropdown,
    Input,
    Button,
    Datepicker,
    SvgIcon,
    Switcher,
  },
  validations: {
    formData: {
      fullname: {
        required,
      },
      placeofbirth: {
        required: requiredIf(function () {
          return this.userCountryCode === ECountryCode.ID;
        }),
      },
      dateofbirth: {},
      gender: {
        required: requiredIf(function () {
          return this.userCountryCode === ECountryCode.ID;
        }),
      },
      occupation: {
        required: requiredIf(function () {
          return this.userCountryCode === ECountryCode.ID;
        }),
      },
      phonenumber: {
        required,
      },
      phonenumbercountrycode: {
        required,
      },
      email: {
        required,
        email,
      },
      isuscitizen: {
        required,
      },
      citizenship: {
        required,
      },
      taxidentificationnumber: {},

      registeredaddressline1: {
        required,
      },
      registeredaddressline2: {},
      registeredcountry: {},
      registeredregion: {
        required,
      },
      registeredcity: {
        required,
      },
      registeredzipcode: {
        required,
      },

      currentaddressline1: {
        required,
      },
      currentaddressline2: {},
      currentcountry: {},
      currentregion: {
        required,
      },
      currentcity: {
        required,
      },
      currentzipcode: {
        required,
      },
    },
  },
})
export default class EditBusinessOwner extends Vue {
  @clientModule.State("currentClient") currentClient!: ClientInfo;

  @Prop({ type: Boolean, default: false }) loading!: boolean;

  countryMobileCodesOption = Object.values(COUNTRY_MOBILE_CODES);

  get userCountryCode() {
    return this.currentClient?.country || "";
  }

  get computedAddressContextTitle() {
    return getAddressTitle(
      this.currentClient?.country,
      this.currentClient?.domicileType
    );
  }
  readonly countryCodes = { ...ECountryCode };
  formData: FormData = initialFormData();
  logoUploadError = "";
  isSameWithAbove = false;

  @Watch("currentClient", { immediate: true })
  watchCurrentClient(value: ClientInfo) {
    this._populateFormData(value);
  }

  _populateFormData(value: ClientInfo) {
    if (!value) return;

    const { countryCode, phoneNumber } = parsePhoneNumber(
      value.businessOwner.phonenumber,
      value.businessOwner.phonenumbercountrycode
    );

    this.formData = {
      fullname: value.businessOwner.fullname,
      placeofbirth: value.businessOwner.placeofbirth,
      dateofbirth: isNaN(+value.businessOwner.dateofbirth)
        ? value.businessOwner.dateofbirth
        : moment.unix(value.businessOwner.dateofbirth).format("DD MMM YYYY"),
      gender: value.businessOwner.gender,
      occupation: value.businessOwner.occupation,
      phonenumber: phoneNumber,
      phonenumbercountrycode: countryCode,
      email: value.businessOwner.email,
      isuscitizen: value.businessOwner.isuscitizen,
      citizenship: value.businessOwner.citizenship,
      taxidentificationnumber: value.businessOwner.taxidentificationnumber,

      registeredaddressline1: value.businessOwner.registeredaddressline1,
      registeredaddressline2: value.businessOwner.registeredaddressline2,
      registeredcountry: value.businessOwner.registeredcountry,
      registeredregion: value.businessOwner.registeredregion,
      registeredcity: value.businessOwner.registeredcity,
      registeredzipcode: value.businessOwner.registeredzipcode,

      currentaddressline1: value.businessOwner.currentaddressline1,
      currentaddressline2: value.businessOwner.currentaddressline2,
      currentcountry: value.businessOwner.currentcountry,
      currentregion: value.businessOwner.currentregion,
      currentcity: value.businessOwner.currentcity,
      currentzipcode: value.businessOwner.currentzipcode,
    };
  }

  onSubmit() {
    this.$v.$touch();
    if (this.$v.$invalid) return;

    this.$emit("submit", this.formData);
  }

  onKeyupAsTIN(e: KeyboardEvent) {
    this.formData = {
      ...this.formData,
      taxidentificationnumber: formatTaxIdNumberUtil(
        (e.target as HTMLTextAreaElement).value
      ),
    } as FormData;
  }

  onKeyupAsPhoneNumber(e: KeyboardEvent) {
    this.formData = {
      ...this.formData,
      phonenumber: formatPhoneNumberUtil(
        (e.target as HTMLTextAreaElement).value
      ),
    } as FormData;
  }

  onKeyupAsNumber(e: KeyboardEvent, keyName: keyof FormData) {
    this.formData = {
      ...this.formData,
      [keyName]: stringToNumberUtil((e.target as HTMLTextAreaElement).value),
    } as FormData;
  }

  handleIsUSCitizen(val: boolean) {
    this.formData.isuscitizen = val;

    const citizenship = val ? ECountryCode.US : this.userCountryCode;

    this.formData = {
      ...this.formData,
      isuscitizen: val,
      citizenship,
    } as FormData;
  }
  handleIsSameWithAbove(val) {
    const newCurrentAddress = {
      currentaddressline1:
        this.formData?.[
          val ? "registeredaddressline1" : "currentaddressline1"
        ] || "",
      currentaddressline2:
        this.formData?.[
          val ? "registeredaddressline2" : "currentaddressline2"
        ] || "",
      currentcountry:
        this.formData?.[val ? "registeredcountry" : "currentcountry"] || "",
      currentregion:
        this.formData?.[val ? "registeredregion" : "currentregion"] || "",
      currentcity:
        this.formData?.[val ? "registeredcity" : "currentcity"] || "",
      currentzipcode:
        this.formData?.[val ? "registeredzipcode" : "currentzipcode"] || "",
    };

    this.formData = {
      ...this.formData,
      ...newCurrentAddress,
    } as FormData;
  }
}
